<template>
  <Navbar :whitetheme="whitetheme" navbaron="meetingmanagement"/>
  <PMM :listCategory="listCategory"/>
  <ScrollToTop />
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import PMM from '@/components/ComponentMeetingManagement/PMM.vue';
import ScrollToTop from '@/components/ScrollToTop.vue';
import axios from 'axios';

export default {
  data(){
    return{
      whitetheme: true,
      listCategory: []
    }
  },
  components:{
    Navbar,
    PMM,
    ScrollToTop,
  },
  created(){
    axios.get(`team`)
    .then(res => {
      this.listCategory = res.data;
    }).catch(err => {
      console.log(err.message);
    })
  },
  methods:{
    scrollup(){
        window.scroll({
            top: 0,
            left: 0,
        })
    },
  },
  mounted(){
      this.scrollup()
  }
}
</script>